import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../ui/dialog";
import { FaLinkedin, FaTelegram } from "react-icons/fa";

import { BsTwitterX } from "react-icons/bs";
import ContactForm from "../ContactForm";
import Link from "next/link";
import StoneLogo from "../StoneLogo";
import { TelegramIcon } from "react-share";
import { siteConfig } from "@/app/_config/siteConfig";

export default function MainFooter() {
  return (
    <footer className="bg-background w-full  ">
      <Dialog>
        <div className="w-full  py-12 px-4 dark:bg-black/30 bg-black/5 md:px-6 lg:px-8">
          <div className="max-w-7xl mx-auto">
            <div className="flex flex-col md:flex-row justify-between gap-8">
              <div className="md:w-1/2 space-y-6">
                <Link href="/">
                  <h2 className="text-2xl font-bold text-foreground">
                    <StoneLogo />
                  </h2>
                </Link>
                <p className="text-muted-foreground max-w-md">
                  {siteConfig.tagLine}
                </p>
                <div className="flex space-x-4">
                  <a
                    href="https://www.linkedin.com/company/writeinstone/"
                    className="text-muted-foreground hover:text-foreground focus:outline-none focus:ring-2 focus:ring-primary rounded-full p-2"
                    aria-label="LinkedIn"
                  >
                    <FaLinkedin size={24} />
                  </a>
                  <a
                    href="https://t.me/WriteInStonePublic"
                    className="text-muted-foreground hover:text-foreground focus:outline-none focus:ring-2 focus:ring-primary rounded-full p-2"
                    aria-label="YouTube"
                  >
                    <FaTelegram size={24} />
                  </a>
                  <a
                    href="https://twitter.com/writeinstone"
                    className="text-muted-foreground hover:text-foreground focus:outline-none focus:ring-2 focus:ring-primary rounded-full p-2"
                    aria-label="Twitter"
                  >
                    <BsTwitterX size={24} />
                  </a>
                </div>
              </div>
              <div className="md:w-1/2 flex flex-col sm:flex-row justify-between gap-8">
                <div className="space-y-4">
                  <h3 className="text-lg font-semibold text-foreground">
                    Quick Links
                  </h3>
                  <ul className="space-y-2">
                    <li>
                      <Link
                        href="/about"
                        className="text-muted-foreground hover:text-foreground focus:outline-none focus:ring-2 focus:ring-primary rounded"
                      >
                        About Us
                      </Link>
                    </li>
                    {/* <li>
                      <Link
                        href="/about"
                        className="text-muted-foreground hover:text-foreground focus:outline-none focus:ring-2 focus:ring-primary rounded"
                      >
                        Our Team
                      </Link>
                    </li> */}
                    <li>
                      <DialogTrigger className="text-muted-foreground hover:text-foreground focus:outline-none focus:ring-2 focus:ring-primary rounded">
                        Contact
                      </DialogTrigger>
                    </li>
                  </ul>
                </div>
                <div className="space-y-4">
                  <h3 className="text-lg font-semibold text-foreground">
                    Legal
                  </h3>
                  <ul className="space-y-2">
                    {/* <li>
                      <Link
                        href="/terms"
                        className="text-muted-foreground hover:text-foreground focus:outline-none focus:ring-2 focus:ring-primary rounded"
                      >
                        Terms of Service
                      </Link>
                    </li> */}
                    <li>
                      <Link
                        href="/privacy"
                        className="text-muted-foreground hover:text-foreground focus:outline-none focus:ring-2 focus:ring-primary rounded"
                      >
                        Privacy Policy
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="mt-12 pt-8 border-t border-muted-foreground/10">
              <p className="text-center text-muted-foreground text-sm">
                © {new Date().getFullYear()} {siteConfig.fullTitle}. All rights
                reserved.
              </p>
            </div>
          </div>
        </div>
        <DialogContent>
          <DialogHeader>
            <DialogTitle className="hidden">Contact Form</DialogTitle>
          </DialogHeader>{" "}
          <ContactForm
            byline={
              "Send us a message directly to our Telegram channel and we'll get back to you rapidly with gusto!"
            }
          />
        </DialogContent>
      </Dialog>
    </footer>
  );
}
